import {CommonBuildConfigurationInput as BuildConfigurationInput} from '../commonConfiguration.types'

import {TruckConfiguration} from './types'

export const buildTruckConfiguration = ({
  options: {constraints}
}: BuildConfigurationInput): TruckConfiguration => {
  if (!constraints.trucks.isEnabled) {
    return {
      trucks: constraints.trucks
    }
  }

  const truckTypes = constraints.trucks.truckTypes
  const defaultTruck = truckTypes.values.find((x) => x.number === truckTypes.default)!

  return {
    trucks: {
      isEnabled: true,
      defaultTruck,
      truckTypes
    }
  }
}
